// import React, { useState } from 'react';
// import { Sidebar } from '@/components/Sidebar';
// import { Button } from '@/components/ui/button';
// import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
// import { Input } from '@/components/ui/input';
// import { Label } from '@/components/ui/label';
// import { Textarea } from '@/components/ui/textarea';
// import {
//   Save,
//   Eye,
//   Smartphone,
//   Monitor,
//   Printer,
//   Image,
//   Type,
//   User,
//   MapPin,
//   DollarSign,
//   Plus,
//   Trash2
// } from 'lucide-react';

// const TemplateBuilder = () => {
//   const [templateName, setTemplateName] = useState('My New Template');
//   const [previewMode, setPreviewMode] = useState<'desktop'>('desktop');

//   const components = [
//     { id: 'image', name: 'Property Image', icon: Image, description: 'Add property photos' },
//     { id: 'text', name: 'Text Block', icon: Type, description: 'Add custom text content' },
//     { id: 'agent', name: 'Agent Info', icon: User, description: 'Agent photo and contact' },
//     { id: 'address', name: 'Property Address', icon: MapPin, description: 'Auto-filled from MLS' },
//     { id: 'price', name: 'Price', icon: DollarSign, description: 'Property price display' }
//   ];

//   const [templateElements, setTemplateElements] = useState([
//     { id: 1, type: 'image', content: 'Property Photo Placeholder' },
//     { id: 2, type: 'address', content: '123 Main Street, City, State 12345' },
//     { id: 3, type: 'price', content: '$450,000' },
//     { id: 4, type: 'text', content: 'Beautiful home with modern amenities...' }
//   ]);

//   const addElement = (type: string) => {
//     const newElement = {
//       id: Date.now(),
//       type,
//       content: `New ${type} element`
//     };
//     setTemplateElements([...templateElements, newElement]);
//   };

//   const removeElement = (id: number) => {
//     setTemplateElements(templateElements.filter(el => el.id !== id));
//   };

//   return (
//     <div className="flex min-h-screen bg-background">
//       <Sidebar />

//       <main className="flex-1 flex">
//         {/* Left Panel - Components & Settings */}
//         <div className="w-80 bg-gradient-card border-r border-border p-6 overflow-y-auto">
//           <div className="mb-6">
//             <h2 className="text-xl font-bold text-black mb-4">Template Builder</h2>

//             <div className="space-y-4">
//               <div>
//                 <Label htmlFor="templateName">Template Name</Label>
//                 <Input
//                   id="templateName"
//                   value={templateName}
//                   onChange={(e) => setTemplateName(e.target.value)}
//                   className="mt-1"
//                 />
//               </div>

//               <div>
//                 <Label className="text-sm font-medium text-black">Preview Mode</Label>
//                 <div className="flex space-x-2 mt-2">
//                   <Button
//                     size="sm"
//                     variant="cta"
//                   >
//                     <Monitor className="h-4 w-4" />
//                   </Button>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Components Library */}
//           <div className="mb-6">
//             <h3 className="font-semibold text-black mb-3">Components</h3>
//             <div className="space-y-2">
//               {components.map((component) => (
//                 <Card key={component.id} className="cursor-pointer transition-smooth hover:shadow-card">
//                   <CardContent className="p-3">
//                     <div className="flex items-center justify-between">
//                       <div className="flex items-center">
//                         <component.icon className="h-5 w-5 text-primary mr-3" />
//                         <div>
//                           <div className="font-medium text-sm">{component.name}</div>
//                           <div className="text-xs text-muted-foreground">{component.description}</div>
//                         </div>
//                       </div>
//                       <Button
//                         size="sm"
//                         variant="ghost"
//                         onClick={() => addElement(component.id)}
//                       >
//                         <Plus className="h-4 w-4" />
//                       </Button>
//                     </div>
//                   </CardContent>
//                 </Card>
//               ))}
//             </div>
//           </div>

//           {/* MLS Auto-Fill */}
//           <Card className="shadow-card">
//             <CardHeader>
//               <CardTitle className="text-sm text-black">MLS Auto-Fill</CardTitle>
//             </CardHeader>
//             <CardContent className="space-y-3">
//               <Button variant="professional" size="sm" className="w-full">
//                 Import Property Data
//               </Button>
//               <p className="text-xs text-muted-foreground">
//                 Connect your MLS to automatically populate property details
//               </p>
//             </CardContent>
//           </Card>
//         </div>

//         {/* Center Panel - Canvas */}
//         <div className="flex-1 p-6">
//           <div className="mb-4 flex justify-between items-center">
//             <h3 className="font-semibold text-black">Live Preview - {previewMode}</h3>
//             <div className="flex space-x-2">
//               <Button variant="outline">
//                 <Eye className="mr-2 h-4 w-4" />
//                 Preview
//               </Button>
//               <Button variant="cta">
//                 <Save className="mr-2 h-4 w-4" />
//                 Save Template
//               </Button>
//             </div>
//           </div>

//           {/* Canvas */}
//           <div className="bg-white shadow-elevated rounded-lg mx-auto transition-smooth max-w-2xl">
//             <div className="p-8 min-h-96">
//               {templateElements.map((element) => (
//                 <div key={element.id} className="group relative mb-4 p-4 border-2 border-dashed border-transparent hover:border-primary/30 rounded transition-smooth">
//                   <div className="flex justify-between items-start">
//                     <div className="flex-1">
//                       {element.type === 'image' && (
//                         <div className="w-full h-48 bg-muted rounded-lg flex items-center justify-center">
//                           <Image className="h-12 w-12 text-muted-foreground" />
//                         </div>
//                       )}
//                       {element.type === 'address' && (
//                         <div className="flex items-center text-lg font-semibold text-primary">
//                           <MapPin className="mr-2 h-5 w-5" />
//                           {element.content}
//                         </div>
//                       )}
//                       {element.type === 'price' && (
//                         <div className="text-2xl font-bold text-cta">
//                           {element.content}
//                         </div>
//                       )}
//                       {element.type === 'text' && (
//                         <p className="text-foreground">{element.content}</p>
//                       )}
//                     </div>
//                     <Button
//                       size="sm"
//                       variant="destructive"
//                       className="opacity-0 group-hover:opacity-100 transition-smooth ml-2"
//                       onClick={() => removeElement(element.id)}
//                     >
//                       <Trash2 className="h-4 w-4" />
//                     </Button>
//                   </div>
//                 </div>
//               ))}

//               {templateElements.length === 0 && (
//                 <div className="text-center text-muted-foreground py-12">
//                   <Type className="h-12 w-12 mx-auto mb-4 opacity-50" />
//                   <p className="text-black">Start building your template by adding components from the left panel.</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default TemplateBuilder;

// "use client";

// import React, { useState, useRef, useEffect, useCallback } from "react";
// import { Sidebar } from "@/components/Sidebar";

// /* ---------- UI COMPONENTS ---------- */
// import { Button } from "@/components/ui/button";
// import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
// import { Input } from "@/components/ui/input";
// import { Label } from "@/components/ui/label";
// import { useToast } from "@/hooks/use-toast";

// /* ---------------------- ICONS ---------------------- */
// import {
//   Save,
//   Eye,
//   Monitor,
//   Smartphone,
//   Image as ImageIcon,
//   Type,
//   User,
//   MapPin,
//   DollarSign,
//   Plus,
//   Trash2,
// } from "lucide-react";

// /* -------------------------- LIBS -------------------------- */
// import axiosInstance from "@/config/axiosInstance";
// import { endpoints } from "@/config/apiEndpoints";

// /* --------------------------- TYPES --------------------------- */
// type Element = {
//   id: number;
//   type: string;
//   content: string;
// };

// type Property = {
//   id: string;
//   title: string;
//   address: string;
//   price: string | number;
//   bedrooms: number;
//   bathrooms: number;
//   area: number;
//   property_type: string;
//   status: string;
//   images?: string[];
//   agent_name?: string;
//   agent_email?: string;
// };

// /* ----------------------- COMPONENT LIST ----------------------- */
// const components = [
//   // {
//   //   id: "image",
//   //   name: "Property Image",
//   //   icon: ImageIcon,
//   //   description: "Add property photos",
//   // },
//   {
//     id: "text",
//     name: "Text Block",
//     icon: Type,
//     description: "Add custom text content",
//   },
//   {
//     id: "agent",
//     name: "Agent Info",
//     icon: User,
//     description: "Agent photo and contact",
//   },
//   {
//     id: "address",
//     name: "Property Address",
//     icon: MapPin,
//     description: "Auto-filled from MLS",
//   },
//   {
//     id: "price",
//     name: "Price",
//     icon: DollarSign,
//     description: "Property price display",
//   },
// ];

// /* ----------------------- DEFAULT CONTENT HELPERS ----------------------- */
// const getDefaultContent = (type: string, property?: Property): string => {
//   if (!property) {
//     switch (type) {
//       case "image":
//         return "Property Photo Placeholder";
//       case "address":
//         return "123 Main Street, City, State 12345";
//       case "price":
//         return "$450,000";
//       case "text":
//         return "Beautiful home with modern amenities...";
//       case "agent":
//         return "Agent Name\nagent@email.com";
//       default:
//         return "New content";
//     }
//   }
//   switch (type) {
//     case "image":
//       return property.images?.[0] ?? "https://via.placeholder.com/600x400";
//     case "address":
//       return property.address ?? "No address";
//     case "price":
//       return typeof property.price === "number"
//         ? `$${property.price.toLocaleString()}`
//         : property.price ?? "$0";
//     case "agent":
//       return `${property.agent_name ?? "Agent Name"}\n${
//         property.agent_email ?? "agent@email.com"
//       }`;
//     case "text":
//       return property.title ?? "Beautiful home with modern amenities...";
//     default:
//       return "New content";
//   }
// };

// /* ----------------------- MAIN COMPONENT ----------------------- */
// export default function TemplateBuilder() {
//   /* -------------------------- STATE -------------------------- */
//   const [templateName, setTemplateName] = useState("My New Template");
//   const [previewMode, setPreviewMode] = useState<"desktop" | "mobile">(
//     "desktop"
//   );

//   const [templateElements, setTemplateElements] = useState<Element[]>([
//     { id: 1, type: "image", content: "" },
//     { id: 2, type: "address", content: "" },
//     { id: 3, type: "price", content: "" },
//     { id: 4, type: "text", content: "" },
//   ]);

//   const [properties, setProperties] = useState<Property[]>([]);
//   const [selectedProperty, setSelectedProperty] = useState<Property | null>(
//     null
//   );
//   const [loadingProperties, setLoadingProperties] = useState(false);
//   const { toast } = useToast();

//   /* ----------------------- UNLAYER ----------------------- */
//   const [EmailEditor, setEmailEditor] = useState<any>(null);
//   const editorRef = useRef<any>(null);
//   const designRef = useRef<any>(null); // keep the current Unlayer design

//   // Load Unlayer client‑side only
//   useEffect(() => {
//     import("react-email-editor").then((mod) =>
//       setEmailEditor(() => mod.default)
//     );
//   }, []);

//   /* ------------------- FETCH PROPERTIES ------------------- */
//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         setLoadingProperties(true);
//         const res = await axiosInstance.get(endpoints.properties);
//         const sorted = [...res.data].sort((a: any, b: any) => {
//           const dateA = new Date(a.created_at || a.id).getTime();
//           const dateB = new Date(b.created_at || b.id).getTime();
//           return dateB - dateA;
//         });
//         setProperties(sorted);
//       } catch (error) {
//         toast({
//           title: "Error",
//           description: "Failed to load properties",
//           variant: "destructive",
//         });
//       } finally {
//         setLoadingProperties(false);
//       }
//     };
//     fetchProperties();
//   }, [toast]);

//   /* ------------------- AUTO‑FILL WHEN PROPERTY CHANGES ------------------- */
//   useEffect(() => {
//     if (!selectedProperty) return;
//     const updated = templateElements.map((el) => ({
//       ...el,
//       content: getDefaultContent(el.type, selectedProperty),
//     }));
//     setTemplateElements(updated);
//   }, [selectedProperty]);

//   /* ------------------- UNLAYER: INITIAL LOAD ------------------- */
//   const buildInitialDesign = useCallback((): any => {
//     return {
//       body: {
//         rows: templateElements.map((el) => {
//           switch (el.type) {
//             case "image":
//               return {
//                 cells: [1],
//                 columns: [
//                   {
//                     contents: [
//                       // {
//                       //   type: "image",
//                       //   values: {
//                       //     src: {
//                       //       url:
//                       //         el.content ||
//                       //         "https://via.placeholder.com/600x400",
//                       //     },
//                       //     alt: "Property image",
//                       //     width: "100%",
//                       //   },
//                       // },
//                     ],
//                     values: { padding: "10px 0px" },
//                   },
//                 ],
//               };
//             case "address":
//               return {
//                 cells: [1],
//                 columns: [
//                   {
//                     contents: [
//                       {
//                         type: "text",
//                         values: {
//                           text: `<p style="font-size:18px;font-weight:600;color:#2563eb;margin:0;">
//                                    <span style="margin-right:8px;">Location</span>${el.content}
//                                  </p>`,
//                         },
//                       },
//                     ],
//                   },
//                 ],
//               };
//             case "price":
//               return {
//                 cells: [1],
//                 columns: [
//                   {
//                     contents: [
//                       {
//                         type: "text",
//                         values: {
//                           text: `<p style="font-size:28px;font-weight:700;color:#dc2626;margin:0;">${el.content}</p>`,
//                         },
//                       },
//                     ],
//                   },
//                 ],
//               };
//             case "agent":
//               return {
//                 cells: [1],
//                 columns: [
//                   {
//                     contents: [
//                       {
//                         type: "text",
//                         values: {
//                           text: `<p style="margin:0;"><strong>${
//                             el.content.split("\n")[0]
//                           }</strong><br/>${el.content.split("\n")[1]}</p>`,
//                         },
//                       },
//                     ],
//                   },
//                 ],
//               };
//             case "text":
//             default:
//               return {
//                 cells: [1],
//                 columns: [
//                   {
//                     contents: [
//                       {
//                         type: "text",
//                         values: {
//                           text: `<p style="margin:0;">${el.content}</p>`,
//                         },
//                       },
//                     ],
//                   },
//                 ],
//               };
//           }
//         }),
//       },
//     };
//   }, [templateElements]);

//   const handleEditorReady = useCallback(() => {
//     const editor = editorRef.current?.editor;
//     if (!editor) return;

//     editor.loadDesign(buildInitialDesign());

//     // Keep design in sync
//     editor.addEventListener("design:updated", (data: any) => {
//       designRef.current = data.design;
//     });
//   }, [buildInitialDesign]);
//   /* ------------------- KEEP templateElements ↔ Unlayer IN SYNC ------------------- */
//   // When Unlayer changes, update our local list (used for the left panel)
//   const syncElementsFromDesign = useCallback(() => {
//     const editor = editorRef.current?.editor;
//     if (!editor) return;

//     editor.exportHtml(({ design }: any) => {
//       const rows = design?.body?.rows ?? [];
//       const newEls: Element[] = rows.map((row: any, idx: number) => {
//         const col = row.columns?.[0];
//         const block = col?.contents?.[0];
//         let type = "text";
//         let content = "";

//         if (block?.type === "image") {
//           type = "image";
//           content = block.values.src?.url ?? "";
//         } else if (block?.type === "text") {
//           const html = block.values.text ?? "";
//           // Heuristic to detect our special blocks
//           if (html.includes("Location")) type = "address";
//           else if (html.includes("font-size:28px")) type = "price";
//           else if (html.includes("<strong>")) type = "agent";
//           else type = "text";

//           // Strip HTML tags for the left‑panel preview
//           content = html.replace(/<[^>]*>/g, "").trim();
//         }

//         return { id: Date.now() + idx, type, content };
//       });

//       setTemplateElements(newEls);
//     });
//   }, []);

//   // Attach sync listener once the editor is ready
//   useEffect(() => {
//     const editor = editorRef.current?.editor;
//     if (!editor) return;

//     const listener = () => syncElementsFromDesign();
//     editor.addEventListener("design:updated", listener);
//     return () => editor.removeEventListener("design:updated", listener);
//   }, [syncElementsFromDesign]);

//   /* ------------------- ADD NEW BLOCK FROM LEFT PANEL ------------------- */
//   /* ------------------- ADD NEW BLOCK FROM LEFT PANEL ------------------- */
//   const addElement = (type: string) => {
//     const editor = editorRef.current?.editor;
//     if (!editor) {
//       toast({ title: "Editor not ready", variant: "destructive" });
//       return;
//     }

//     const content = getDefaultContent(type, selectedProperty);

//     // 1. Get current design
//     editor.exportHtml(({ design }: any) => {
//       const rows = design?.body?.rows || [];

//       // 2. Create new row
//       let newRow: any = {};
//       let newBlock: any = {};

//       switch (type) {
//         // case "image":
//         //   newBlock = {
//         //     type: "image",
//         //     values: {
//         //       src: { url: content },
//         //       alt: "Property image",
//         //       width: "100%",
//         //     },
//         //   };
//         //   break;
//         case "address":
//           newBlock = {
//             type: "text",
//             values: {
//               text: `<p style="font-size:18px;font-weight:600;color:#2563eb;margin:0;">
//                      <span style="margin-right:8px;">Location</span>${content}
//                    </p>`,
//             },
//           };
//           break;
//         case "price":
//           newBlock = {
//             type: "text",
//             values: {
//               text: `<p style="font-size:28px;font-weight:700;color:#dc2626;margin:0;">${content}</p>`,
//             },
//           };
//           break;
//         case "agent":
//           newBlock = {
//             type: "text",
//             values: {
//               text: `<p style="margin:0;"><strong>${
//                 content.split("\n")[0]
//               }</strong><br/>${content.split("\n")[1]}</p>`,
//             },
//           };
//           break;
//         case "text":
//         default:
//           newBlock = {
//             type: "text",
//             values: { text: `<p style="margin:0;">${content}</p>` },
//           };
//           break;
//       }

//       newRow = {
//         cells: [1],
//         columns: [
//           {
//             contents: [newBlock],
//             values: { padding: "10px 0px" },
//           },
//         ],
//       };

//       // 3. Append new row
//       const updatedDesign = {
//         ...design,
//         body: {
//           ...design.body,
//           rows: [...rows, newRow],
//         },
//       };

//       // 4. Reload design (preserves all edits)
//       editor.loadDesign(updatedDesign);

//       // Optional: update local state
//       const newEl: Element = {
//         id: Date.now(),
//         type,
//         content,
//       };
//       setTemplateElements((prev) => [...prev, newEl]);
//     });
//   };
//   /* ------------------- REMOVE BLOCK FROM LEFT PANEL ------------------- */
//   /* ------------------- REMOVE BLOCK FROM LEFT PANEL ------------------- */
//   const removeElement = (id: number) => {
//     const idx = templateElements.findIndex((el) => el.id === id);
//     if (idx === -1) return;

//     const editor = editorRef.current?.editor;
//     if (!editor) return;

//     editor.exportHtml(({ design }: any) => {
//       const rows = design?.body?.rows || [];
//       if (idx >= rows.length) return;

//       const updatedRows = rows.filter((_: any, i: number) => i !== idx);
//       const updatedDesign = {
//         ...design,
//         body: {
//           ...design.body,
//           rows: updatedRows,
//         },
//       };

//       editor.loadDesign(updatedDesign);
//       setTemplateElements((prev) => prev.filter((el) => el.id !== id));
//     });
//   };
//   /* -------------------------- SAVE -------------------------- */
//   const handleSave = () => {
//     const editor = editorRef.current?.editor;
//     if (!editor) {
//       toast({ title: "Editor not ready", variant: "destructive" });
//       return;
//     }

//     editor.exportHtml(async ({ design, html }: any) => {
//       const payload = {
//         name: templateName,
//         elements: templateElements,
//         unlayerDesign: design,
//         html,
//         previewMode,
//         property_id: selectedProperty?.id ?? null,
//       };

//       try {
//         await axiosInstance.post(endpoints.campaigns, payload);
//         toast({ title: "Success", description: "Template saved!" });
//       } catch (e: any) {
//         console.error(e);
//         toast({
//           title: "Error",
//           description: e?.response?.data?.message ?? "Save failed",
//           variant: "destructive",
//         });
//       }
//     });
//   };

//   const showPreview = () => editorRef.current?.editor?.showPreview?.();

//   /* ----------------------- LOADING ----------------------- */
//   if (!EmailEditor) {
//     return (
//       <div className="flex h-screen items-center justify-center bg-gray-50">
//         <p className="text-lg font-medium text-gray-600">
//           Loading Template Builder…
//         </p>
//       </div>
//     );
//   }

//   /* --------------------------- UI --------------------------- */
//   return (
//     <div className="flex min-h-screen bg-background">
//       <Sidebar />

//       <main className="flex flex-1">
//         {/* ---------- LEFT PANEL ---------- */}
//         <aside className="w-80 border-r border-border bg-card p-6 overflow-y-auto">
//           <h2 className="mb-6 text-xl font-bold text-foreground">
//             Template Builder
//           </h2>

//           {/* Template Name */}
//           <div className="mb-6 space-y-2">
//             <Label htmlFor="templateName">Template Name</Label>
//             <Input
//               id="templateName"
//               value={templateName}
//               onChange={(e) => setTemplateName(e.target.value)}
//               placeholder="Enter template name"
//             />
//           </div>

//           {/* Property Selector */}
//           <div className="mb-6 space-y-2">
//             <Label>Property (optional)</Label>
//             {loadingProperties ? (
//               <p className="text-sm text-muted-foreground">
//                 Loading properties…
//               </p>
//             ) : (
//               <select
//                 className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
//                 value={selectedProperty?.id ?? ""}
//                 onChange={(e) => {
//                   const prop =
//                     properties.find((p) => p.id === e.target.value) ?? null;
//                   setSelectedProperty(prop);
//                 }}
//               >
//                 <option value="">— No property —</option>
//                 {properties.map((p) => (
//                   <option key={p.id} value={p.id}>
//                     {p.title} – ${Number(p.price).toLocaleString()}
//                   </option>
//                 ))}
//               </select>
//             )}
//           </div>

//           {/* Preview Mode */}
//           <div className="mb-6">
//             <Label className="text-sm font-medium">Preview Mode</Label>
//             <div className="mt-2 flex gap-2">
//               <Button
//                 size="sm"
//                 variant={previewMode === "desktop" ? "default" : "outline"}
//                 onClick={() => setPreviewMode("desktop")}
//               >
//                 <Monitor className="mr-1 h-4 w-4" />
//                 Desktop
//               </Button>
//               <Button
//                 size="sm"
//                 variant={previewMode === "mobile" ? "default" : "outline"}
//                 onClick={() => setPreviewMode("mobile")}
//               >
//                 <Smartphone className="mr-1 h-4 w-4" />
//                 Mobile
//               </Button>
//             </div>
//           </div>

//           {/* Components Library */}
//           <section className="mb-6">
//             <h3 className="mb-3 text-sm font-semibold text-foreground">
//               Components
//             </h3>
//             <div className="space-y-2">
//               {components.map((c) => (
//                 <Card
//                   key={c.id}
//                   className="cursor-pointer transition-shadow hover:shadow-sm"
//                   onClick={() => addElement(c.id)}
//                 >
//                   <CardContent className="p-3">
//                     <div className="flex items-center justify-between">
//                       <div className="flex items-center gap-3">
//                         <c.icon className="h-5 w-5 text-primary" />
//                         <div>
//                           <p className="text-sm font-medium">{c.name}</p>
//                           <p className="text-xs text-muted-foreground">
//                             {c.description}
//                           </p>
//                         </div>
//                       </div>
//                       <Button size="sm" variant="ghost">
//                         <Plus className="h-4 w-4" />
//                       </Button>
//                     </div>
//                   </CardContent>
//                 </Card>
//               ))}
//             </div>
//           </section>

//           {/* MLS Auto‑Fill */}
//           {/* <Card className="border shadow-sm">
//             <CardHeader className="pb-3">
//               <CardTitle className="text-sm font-medium">
//                 MLS Auto‑Fill
//               </CardTitle>
//             </CardHeader>
//             <CardContent className="space-y-3">
//               <Button variant="outline" size="sm" className="w-full">
//                 Import Property Data
//               </Button>
//               <p className="text-xs text-muted-foreground">
//                 Connect your MLS to auto‑populate address, price & photos.
//               </p>
//             </CardContent>
//           </Card> */}
//         </aside>

//         {/* ---------- CENTER CANVAS ---------- */}
//         <section className="flex-1 p-6">
//           {/* Toolbar */}
//           <div className="mb-4 flex items-center justify-between">
//             <h3 className="text-lg font-semibold text-foreground">
//               Live Preview — {previewMode === "desktop" ? "Desktop" : "Mobile"}
//             </h3>
//             <div className="flex gap-2">
//               {/* <Button variant="outline" size="sm" onClick={showPreview}>
//                 <Eye className="mr-2 h-4 w-4" />
//                 Preview
//               </Button> */}
//               <Button variant="default" size="sm" onClick={handleSave}>
//                 <Save className="mr-2 h-4 w-4" />
//                 Save Template
//               </Button>
//             </div>
//           </div>

//           {/* Unlayer Editor */}
//           <div className="rounded-lg border bg-white shadow-lg overflow-hidden">
//             <EmailEditor
//               ref={editorRef}
//               onLoad={handleEditorReady}
//               style={{ height: "calc(100vh - 200px)", minHeight: "600px" }}
//               options={{
//                 appearance: { theme: "light" },
//                 displayMode: previewMode,
//                 mergeTags: [
//                   { name: "Address", value: "{{address}}" },
//                   { name: "Price", value: "{{price}}" },
//                   { name: "Agent Name", value: "{{agent_name}}" },
//                 ],
//                 // THIS IS THE FIX
//                 exporters: {
//                   desktop: {
//                     // default exporters – copy‑paste from Unlayer docs
//                     image: (block) => block.values.src?.url ?? "",
//                     text: (block) => block.values.text ?? "",
//                     // containers just return empty string – they are structural
//                     content: () => "",
//                     column: () => "",
//                     row: () => "",
//                     body: () => "",
//                   },
//                 },
//               }}
//             />
//           </div>

//           {/* Optional Element List (shows what is currently in the design) */}
//           {/* <div className="mt-6">
//             <h4 className="mb-2 text-sm font-medium text-foreground">Added Elements</h4>
//             {templateElements.length === 0 ? (
//               <p className="text-sm text-muted-foreground">
//                 Add components from the left panel or edit inside the editor.
//               </p>
//             ) : (
//               <div className="space-y-2">
//                 {templateElements.map((el) => (
//                   <div
//                     key={el.id}
//                     className="group flex items-center justify-between rounded-md border bg-background p-3"
//                   >
//                     <div className="flex items-center gap-2">
//                       {el.type === 'image' && <ImageIcon className="h-4 w-4 text-blue-600" />}
//                       {el.type === 'address' && <MapPin className="h-4 w-4 text-green-600" />}
//                       {el.type === 'price' && <DollarSign className="h-4 w-4 text-red-600" />}
//                       {el.type === 'text' && <Type className="h-4 w-4 text-gray-600" />}
//                       {el.type === 'agent' && <User className="h-4 w-4 text-purple-600" />}
//                       <span className="text-sm font-medium">{el.content || '(empty)'}</span>
//                     </div>
//                     <Button
//                       size="sm"
//                       variant="ghost"
//                       className="opacity-0 group-hover:opacity-100 transition-opacity"
//                       onClick={() => removeElement(el.id)}
//                     >
//                       <Trash2 className="h-4 w-4 text-destructive" />
//                     </Button>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div> */}
//         </section>
//       </main>
//     </div>
//   );
// }

"use client";

import React, { useState, useRef, useEffect, useCallback } from "react";
import { Sidebar } from "@/components/Sidebar";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { PageHeader } from "@/components/Header";

import {
  Save,
  Eye,
  Monitor,
  Smartphone,
  Image as ImageIcon,
  Type,
  User,
  MapPin,
  DollarSign,
  Plus,
  Trash2,
  ArrowLeft,
  ArrowRight,
  CheckCircle,
  Send,
  Loader2,
  RefreshCw,
} from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';

import axiosInstance from "@/config/axiosInstance";
import { endpoints } from "@/config/apiEndpoints";
import { useNavigate } from "react-router-dom";

type Element = {
  id: number;
  type: string;
  content: string;
};

type Property = {
  id: string;
  title: string;
  address: string;
  price: string | number;
  bedrooms: number;
  bathrooms: number;
  area: number;
  property_type: string;
  status: string;
  images?: string[];
  agent_name?: string;
  agent_email?: string;
};

const components = [
  {
    id: "text",
    name: "Text Block",
    icon: Type,
    description: "Add custom text content",
  },
  {
    id: "agent",
    name: "Agent Info",
    icon: User,
    description: "Agent photo and contact",
  },
  {
    id: "address",
    name: "Property Address",
    icon: MapPin,
    description: "Auto-filled from MLS",
  },
  {
    id: "price",
    name: "Price",
    icon: DollarSign,
    description: "Property price display",
  },
];

const getDefaultContent = (type: string, property?: Property): string => {
  if (!property) {
    switch (type) {
      case "image":
        return "Property Photo Placeholder";
      case "address":
        return "123 Main Street, City, State 12345";
      case "price":
        return "$450,000";
      case "text":
        return "Beautiful home with modern amenities...";
      case "agent":
        return "Agent Name\nagent@email.com";
      default:
        return "New content";
    }
  }
  switch (type) {
    case "image":
      return property.images?.[0] ?? "https://via.placeholder.com/600x400";
    case "address":
      return property.address ?? "No address";
    case "price":
      return typeof property.price === "number"
        ? `$${property.price.toLocaleString()}`
        : property.price ?? "$0";
    case "agent":
      return `${property.agent_name ?? "Agent Name"}\n${
        property.agent_email ?? "agent@email.com"
      }`;
    case "text":
      return property.title ?? "Beautiful home with modern amenities...";
    default:
      return "New content";
  }
};

export default function TemplateBuilder() {
  const [templateName, setTemplateName] = useState("My New Template");
  // when we save a template we store the created custom template id here so
  // a subsequent campaign created from this builder can reference it.
  const [savedCustomTemplateId, setSavedCustomTemplateId] = useState<number | null>(null);
  const [previewMode, setPreviewMode] = useState<"desktop" | "mobile">(
    "desktop"
  );
  const [templateElements, setTemplateElements] = useState<Element[]>([
    { id: 1, type: "image", content: "" },
    { id: 2, type: "address", content: "" },
    { id: 3, type: "price", content: "" },
    { id: 4, type: "text", content: "" },
  ]);
  const [properties, setProperties] = useState<Property[]>([]);
  const [selectedProperty, setSelectedProperty] = useState<Property | null>(
    null
  );
  const [loadingProperties, setLoadingProperties] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  const [EmailEditor, setEmailEditor] = useState<any>(null);
  const editorRef = useRef<any>(null);
  const designRef = useRef<any>(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showPricingModal, setShowPricingModal] = useState(false);
   const [showAddOnModal, setShowAddOnModal] = useState(false)

  useEffect(() => {
      import("react-email-editor").then((mod) =>
      setEmailEditor(() => mod.default)
      );
  }, []);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoadingProperties(true);
        const res = await axiosInstance.get(endpoints.properties);
        const sorted = [...res.data].sort((a: any, b: any) => {
          const dateA = new Date(a.created_at || a.id).getTime();
          const dateB = new Date(b.created_at || b.id).getTime();
          return dateB - dateA;
        });
        setProperties(sorted);
      } catch (error) {
        toast({
          title: "Error",
          description: "Failed to load properties",
          variant: "destructive",
        });
      } finally {
        setLoadingProperties(false);
      }
    };
    fetchProperties();
  }, [toast]);

  useEffect(() => {
    if (!selectedProperty) return;
    const updated = templateElements.map((el) => ({
      ...el,
      content: getDefaultContent(el.type, selectedProperty),
    }));
    setTemplateElements(updated);
  }, [selectedProperty]);

  const buildInitialDesign = useCallback((): any => {
    return {
      body: {
        rows: templateElements.map((el) => {
          switch (el.type) {
            case "image":
              return {
                cells: [1],
                columns: [{ contents: [], values: { padding: "10px 0px" } }],
              };
            case "address":
              return {
                cells: [1],
                columns: [
                  {
                    contents: [
                      {
                        type: "text",
                        values: {},
                      },
                    ],
                  },
                ],
              };
            case "price":
              return {
                cells: [1],
                columns: [
                  {
                    contents: [
                      {
                        type: "text",
                        values: {
                          text: `<p style="font-size:28px;font-weight:700;color:#dc2626;margin:0;">${el.content}</p>`,
                        },
                      },
                    ],
                  },
                ],
              };
            case "agent":
              return {
                cells: [1],
                columns: [
                  {
                    contents: [
                      {
                        type: "text",
                        values: {
                          text: `<p style="margin:0;"><strong>${
                            el.content.split("\n")[0]
                          }</strong><br/>${el.content.split("\n")[1]}</p>`,
                        },
                      },
                    ],
                  },
                ],
              };
            case "text":
            default:
              return {
                cells: [1],
                columns: [
                  {
                    contents: [
                      {
                        type: "text",
                        values: {
                          text: `<p style="margin:0;">${el.content}</p>`,
                        },
                      },
                    ],
                  },
                ],
              };
          }
        }),
      },
    };
  }, [templateElements]);

  const handleEditorReady = useCallback(() => {
    const editor = editorRef.current?.editor;
    if (!editor) return;
    editor.loadDesign(buildInitialDesign());
    editor.addEventListener("design:updated", (data: any) => {
      designRef.current = data.design;
    });
  }, [buildInitialDesign]);

  const syncElementsFromDesign = useCallback(() => {
    const editor = editorRef.current?.editor;
    if (!editor) return;

    editor.exportHtml(({ design }: any) => {
      const rows = design?.body?.rows ?? [];
      const newEls: Element[] = rows.map((row: any, idx: number) => {
        const col = row.columns?.[0];
        const block = col?.contents?.[0];
        let type = "text";
        let content = "";

        if (block?.type === "image") {
          type = "image";
          content = block.values.src?.url ?? "";
        } else if (block?.type === "text") {
          const html = block.values.text ?? "";
          if (html.includes("Location")) type = "address";
          else if (html.includes("font-size:28px")) type = "price";
          else if (html.includes("<strong>")) type = "agent";
          else type = "text";

          content = html.replace(/<[^>]*>/g, "").trim();
        }

        return { id: Date.now() + idx, type, content };
      });
      setTemplateElements(newEls);
    });
  }, []);

  useEffect(() => {
    const editor = editorRef.current?.editor;
    if (!editor) return;
    const listener = () => syncElementsFromDesign();
    editor.addEventListener("design:updated", listener);
    return () => editor.removeEventListener("design:updated", listener);
  }, [syncElementsFromDesign]);

  const addElement = (type: string) => {
    const editor = editorRef.current?.editor;
    if (!editor) {
      toast({ title: "Editor not ready", variant: "destructive" });
      return;
    }

    const content = getDefaultContent(type, selectedProperty);
    editor.exportHtml(({ design }: any) => {
      const rows = design?.body?.rows || [];
      let newBlock: any = {};
      switch (type) {
        case "address":
          newBlock = {
            type: "text",
            values: {
              text: `<p style="font-size:18px;font-weight:600;color:#2563eb;margin:0;"><span style="margin-right:8px;">Location</span>${content}</p>`,
            },
          };
          break;
        case "price":
          newBlock = {
            type: "text",
            values: {
              text: `<p style="font-size:28px;font-weight:700;color:#dc2626;margin:0;">${content}</p>`,
            },
          };
          break;
        case "agent":
          newBlock = {
            type: "text",
            values: {
              text: `<p style="margin:0;"><strong>${
                content.split("\n")[0]
              }</strong><br/>${content.split("\n")[1]}</p>`,
            },
          };
          break;
        case "text":
        default:
          newBlock = {
            type: "text",
            values: { text: `<p style="margin:0;">${content}</p>` },
          };
          break;
      }

      const newRow = {
        cells: [1],
        columns: [{ contents: [newBlock], values: { padding: "10px 0px" } }],
      };

      editor.loadDesign({
        ...design,
        body: { ...design.body, rows: [...rows, newRow] },
      });

      setTemplateElements((prev) => [
        ...prev,
        { id: Date.now(), type, content },
      ]);
    });
  };

  const removeElement = (id: number) => {
    const idx = templateElements.findIndex((el) => el.id === id);
    if (idx === -1) return;

    const editor = editorRef.current?.editor;
    if (!editor) return;

    editor.exportHtml(({ design }: any) => {
      const rows = design?.body?.rows || [];
      const updatedRows = rows.filter((_: any, i: number) => i !== idx);
      editor.loadDesign({
        ...design,
        body: { ...design.body, rows: updatedRows },
      });
      setTemplateElements((prev) => prev.filter((el) => el.id !== id));
    });
  };

  const handleSave = async () => {
    const editor = editorRef.current?.editor;
    if (!editor) {
      toast({ title: "Editor not ready", variant: "destructive" });
      return false;
    }

    return new Promise<boolean>((resolve) => {
      editor.exportHtml(async ({ design, html }: any) => {
        const payload = {
          name: templateName,
          elements: templateElements,
          unlayerDesign: design,
          html,
          previewMode,
          property_id: selectedProperty?.id ?? null,
        };

        try {
          const res = await axiosInstance.post(endpoints.custom_templates, payload);
          const created = res?.data;
          // store id for later campaign creation
          if (created?.id) setSavedCustomTemplateId(created.id);
          toast({ title: "Success", description: "Template saved!" });
          resolve(created ?? true);
        } catch (e: any) {
          toast({
            title: "Error",
            description: e?.response?.data?.message ?? "Save failed",
            variant: "destructive",
          });
          resolve(false);
        }
      });
    });
  };

  const [currentStep, setCurrentStep] = useState(1);
  const [statesList, setStatesList] = useState<
    { id: number; state_name: string }[]
  >([]);
  const [agentLists, setAgentLists] = useState<
    { id: string; name: string; count: number }[]
  >([]);
  const [selectedState, setSelectedState] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [selectedDatasets, setSelectedDatasets] = useState<string[]>([]);
  const [selectedDateTime, setSelectedDateTime] = useState("");
  const [subject, setSubject] = useState("");
  const [error, setError] = useState("");
  const [isRegenerating, setIsRegenerating] = useState(false);
  const [generationCount, setGenerationCount] = useState(0);
  const [planLoading, setPlanLoading] = useState(false);
  const [countLoading, setCountLoading] = useState(false);
  const [userPlan, setUserPlan] = useState<string | null>(null);
  const [campaignsSent, setCampaignsSent] = useState<number>(0);
  const [planLimits, setPlanLimits] = useState<Record<string, number>>({});

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await axiosInstance.get(endpoints.db_states);
        setStatesList(res.data);
      } catch {
        toast({
          title: "Error",
          description: "Failed to load states",
          variant: "destructive",
        });
      }
    };
    fetchStates();
  }, [toast]);

  useEffect(() => {
    if (!selectedState) {
      setAgentLists([]);
      return;
    }
    const fetchAgentLists = async () => {
      try {
        const res = await axiosInstance.get(
          `${endpoints.db_cities}?state=${selectedState.id}`
        );
        const data = (
          Array.isArray(res.data) ? res.data : res.data.results || []
        ).map((city: any) => ({
          id: String(city.id || city.pk || Math.random()),
          name: city.city_name || city.name || "Unknown",
          count: city.agent_count || city.agents?.length || 0,
        }));
        setAgentLists(data);
      } catch {
        toast({
          title: "Error",
          description: "Failed to load agent lists",
          variant: "destructive",
        });
      }
    };
    fetchAgentLists();
  }, [selectedState, toast]);

  useEffect(() => {
    const fetchPlanLimits = async () => {
      try {
        const { data } = await axiosInstance.get(endpoints.plans);
        const limits: Record<string, number> = {};
        data.forEach((p: any) => (limits[p.name] = p.Campaigns ?? 0));
        setPlanLimits(limits);
      } catch (err) {
        console.error(err);
      }
    };
    fetchPlanLimits();
  }, []);

  const handleRegenerateSubject = async () => {
    if (isRegenerating) return;
    setIsRegenerating(true);
    setGenerationCount((c) => c + 1);

    const address = selectedProperty?.address || "";
    const price = selectedProperty?.price || 0;
    const headline = selectedProperty?.title || "Featured Property";
    const bedrooms = selectedProperty?.bedrooms || 0;
    const bathrooms = selectedProperty?.bathrooms || 0;
    const area = selectedProperty?.area || 0;
    const description = (selectedProperty?.description || "").slice(0, 120);

    const prompt = `
You are a real-estate email-marketing expert. Generate **3** short, catchy subject lines (max 50 characters each) for a property Launch. Use the data below and focus on urgency, exclusivity or value.

- Address: ${address}
- Price: $${price.toLocaleString()}
- Headline: ${headline}
- ${bedrooms} bed • ${bathrooms} bath • ${area} sqft
- Description snippet: ${description}...

Output **only** the three lines, one per line, no numbering.
`.trim();

    try {
        // Call backend generation endpoint instead of OpenAI directly
        const resp = await axiosInstance.post(endpoints.generate_subject, {
          address: address,
          price: price,
          headline: headline,
          bedrooms: bedrooms,
          bathrooms: bathrooms,
          area: area,
          description: description,
        });

        const lines = Array.isArray(resp.data.subjects) ? resp.data.subjects : [];
        if (!lines.length) throw new Error("No subject generated");
        setSubject(lines[Math.floor(Math.random() * lines.length)]);
        if (error) setError("");
    } catch (err: any) {
      toast({
        title: "Regenerate failed",
        description: err.message,
        variant: "destructive",
      });
    } finally {
      setIsRegenerating(false);
    }
  };

  const MAX_GENERATIONS = 3;

  const getButtonText = () => {
    if (generationCount === 0) return "Generate";
    if (generationCount < MAX_GENERATIONS) {
      const left = MAX_GENERATIONS - generationCount;
      return `Regenerate (${left} left)`;
    }
    return "Limit Reached";
  };

  const handleSendCampaign = async () => {
    try {
      if (!subject.trim()) {
        setError("Please add subject");
        toast({
          title: "Missing Subject",
          description: "Please enter a launch subject.",
          variant: "destructive",
        });
        return;
      }

      if (!selectedDateTime) {
      toast({
        title: "Missing Schedule",
        description: "Please select date and time.",
        variant: "destructive",
      });
      return;
    }

      if (new Date(selectedDateTime) < new Date()) {
      toast({
        title: "Invalid Date",
        description: "You cannot schedule a launch in the past.",
        variant: "destructive",
      });
      return;
    }
      if (selectedDatasets.length === 0) {
        toast({
          title: "No Dataset",
          description: "Select at least one agent database.",
          variant: "destructive",
        });
        return;
      }
      setPlanLoading(true);
      // 1. Get fresh user data
      const { data: user } = await axiosInstance.get(endpoints.me);
      // BLOCK IF SUBSCRIPTION IS PAUSED
      if (user.pause_count > 0) {
        toast({
          title: "Subscription Paused",
          description: "Your subscription is currently paused. Please resume it in Billing to send launches.",
          variant: "destructive",
        });
        setPlanLoading(false);
        return;
      }
      // BLOCK IF NO ACTIVE PLAN
      if (!user.plan_name) {
        toast({ title: "No Plan", description: "Subscribe first", variant: "destructive" });
        setShowPricingModal(true);
        setPlanLoading(false);
        return;
      }
      const totalLimit = user.total_campaign_limit;
      const sent = user.campaigns_sent_this_month;
      // BLOCK IF THIS CAMPAIGN WOULD EXCEED LIMIT
      if (sent + 1 > totalLimit) {
        toast({
          title: "Campaign Limit Exceeded",
          description: `You've reached your limit of ${totalLimit} launches this month.`,
          variant: "destructive",
        });
        setShowAddOnModal(true);
        setPlanLoading(false);
        return;
      }

      const payload = {
        campaign_type: "PROPERTY",
        campaign_subject: subject.trim(),
        property_id: selectedProperty?.id || null,
        state_id: selectedState?.id || null,
        city_id: selectedDatasets.map((id) => Number(id)),
        // Prefer explicit custom_template_id when we saved a template in this flow
        template: templateName || "",
        custom_template_id: savedCustomTemplateId ?? undefined,
        scheduled_date: selectedDateTime,
      };

      const resp = await axiosInstance.post(endpoints.createCampaign, payload);
      toast({
        title: "Scheduled",
        description: `Will run on ${new Date(
          selectedDateTime
        ).toLocaleString()}.`,
        variant: "success",
      });

      // Navigate to Campaign Management after successful create
      try {
        navigate("/launches");
      } catch (e) {
        // ignore navigation errors
      }
    } catch (err: any) {
      toast({
        title: "Error",
        description: err.response?.data?.message || "Failed",
        variant: "destructive",
      });
    } finally {
      setPlanLoading(false);
    }
  };

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const utcToDateInputValue = (isoString: string) => {
    return new Date(isoString).toISOString().slice(0, 16);
  };

  const formatDateTime = (isoString: string) => {
    return new Date(isoString).toLocaleString();
  };

  const handleNext = async () => {
    if (currentStep === 1) {
      const saved = await handleSave();
      if (saved) setCurrentStep(2);
    } else if (currentStep === 2) {
      setCurrentStep(3);
    } else if (currentStep === 3) {
      await handleSendCampaign();
    }
  };

  const handleBack = () => setCurrentStep((prev) => Math.max(1, prev - 1));

  /* ------------------- STEP 1: UNCHANGED STYLING ------------------- */
  const renderStep1 = () => (
    <div className="flex">
      {/* LEFT PANEL */}
      <aside className="w-80 border-r border-border bg-card p-6 overflow-y-auto">
        <h2 className="mb-6 text-xl font-bold text-foreground">
          Template Builder
        </h2>

        {/* Template Name */}
        <div className="mb-6 space-y-2">
          <Label htmlFor="templateName">Template Name</Label>
          <Input
            id="templateName"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
            placeholder="Enter template name"
          />
        </div>

        {/* Property Selector */}
        {/* <div className="mb-6 space-y-2">
          <Label>Property (optional)</Label>
          {loadingProperties ? (
            <p className="text-sm text-muted-foreground">Loading…</p>
          ) : (
            <select
              className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
              value={selectedProperty?.id ?? ""}
              onChange={(e) => {
                const prop =
                  properties.find((p) => p.id === e.target.value) ?? null;
                setSelectedProperty(prop);
              }}
            >
              <option value="">— No property —</option>
              {properties.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.title} – ${Number(p.price).toLocaleString()}
                </option>
              ))}
            </select>
          )}
        </div> */}

        {/* Preview Mode */}
        {/* <div className="mb-6">
          <Label className="text-sm font-medium">Preview Mode</Label>
          <div className="mt-2 flex gap-2">
            <Button
              size="sm"
              variant={previewMode === "desktop" ? "default" : "outline"}
              onClick={() => setPreviewMode("desktop")}
            >
              <Monitor className="mr-1 h-4 w-4" />
              Desktop
            </Button>
            <Button
              size="sm"
              variant={previewMode === "mobile" ? "default" : "outline"}
              onClick={() => setPreviewMode("mobile")}
            >
              <Smartphone className="mr-1 h-4 w-4" />
              Mobile
            </Button>
          </div>
        </div> */}

        {/* Components */}
        <section className="mb-6">
          <h3 className="mb-3 text-sm font-semibold text-foreground">
            Components
          </h3>
          <div className="space-y-2">
            {components.map((c) => (
              <Card
                key={c.id}
                className="cursor-pointer transition-shadow hover:shadow-sm"
                onClick={() => addElement(c.id)}
              >
                <CardContent className="p-3">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <c.icon className="h-5 w-5 text-primary" />
                      <div>
                        <p className="text-sm font-medium">{c.name}</p>
                        <p className="text-xs text-muted-foreground">
                          {c.description}
                        </p>
                      </div>
                    </div>
                    <Button size="sm" variant="ghost">
                      <Plus className="h-4 w-4" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>
      </aside>

      {/* CENTER CANVAS */}
      <section className="flex-1 p-6">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-foreground">
            Live Preview — {previewMode === "desktop" ? "Desktop" : "Mobile"}
          </h3>
          <Button variant="default" size="sm" onClick={handleNext}>
            Next <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>

        <div className="rounded-lg border bg-white shadow-lg overflow-hidden">
          <EmailEditor
            ref={editorRef}
            onLoad={handleEditorReady}
            style={{ height: "calc(100vh - 200px)", minHeight: "600px" }}
            options={{
              appearance: { theme: "light" },
              // displayMode: previewMode,
              mergeTags: [
                { name: "Address", value: "{{address}}" },
                { name: "Price", value: "{{price}}" },
                { name: "Agent Name", value: "{{agent_name}}" },
              ],
            }}
          />
        </div>
      </section>
    </div>
  );

  const renderStep2 = () => (
    <div className="max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold text-primary mb-8 text-center">
        Select Dataset
      </h2>
  
      {/* State Selection */}
      <div className="mb-8 flex items-center justify-center gap-4">
        <Label className="text-lg font-semibold text-primary">
          Select State
        </Label>
        <select
          value={selectedState?.id ?? ""}
          onChange={(e) => {
            const s = statesList.find((st) => st.id.toString() === e.target.value);
            if (s) setSelectedState({ id: s.id, name: s.state_name });
          }}
          className="w-48 rounded-md border border-input bg-background px-3 py-2"
        >
          <option value="">Select State</option>
          {statesList.map((s) => (
            <option key={s.id} value={s.id}>
              {s.state_name}
            </option>
          ))}
        </select>
      </div>
  
      {/* Info Box - EXACT TEXT FROM CAMPAIGNBUILDER SERVICE FLOW */}
      <div className="mb-6 p-4 border-2 border-dashed border-muted rounded-lg bg-muted/20">
        <p className="text-sm text-muted-foreground leading-relaxed">
          <strong>
            Agents in our database are broken down by the association they belong to. Select a state to see the databases within that state.
          </strong>
        </p>
        <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
          <strong>Note:</strong> Many agents subscribe to multiple databases as well as select specific property type preferences for the emails they receive. The estimated reach for your particular order may be different than the numbers shown below. Also, be advised that we do not have every agent in our database and agents do unsubscribe from emails which may reduce your estimated reach of your particular order on the "payment step" prior to paying for your order.{" "}
          <span className="text-primary underline cursor-pointer">
            Please see our FAQ page for more details.
          </span>
        </p>
      </div>
  
      {/* Rest of your agent list rendering stays the same */}
      <div className="grid gap-4 max-h-[350px] overflow-y-auto pr-2">
        {agentLists.map((list) => (
          <div
            key={list.id}
            className={`border rounded-lg p-4 transition-all ${
              selectedDatasets.includes(list.id)
                ? "bg-primary/10 border-primary shadow-lg"
                : "bg-background border-border hover:shadow-card"
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="text-primary font-medium">
                {list.name} -{" "}
                <strong className="text-foreground">
                  {(list.agent_count ?? list.count ?? 0).toLocaleString()}
                </strong>
              </span>
              {selectedDatasets.includes(list.id) ? (
                <Button
                  variant="destructive"
                  size="sm"
                  onClick={() =>
                    setSelectedDatasets((p) => p.filter((x) => x !== list.id))
                  }
                >
                  Remove
                </Button>
              ) : (
                <Button
                  variant="destructive"
                  size="sm"
                  onClick={() => setSelectedDatasets((p) => [...p, list.id])}
                  className="min-w-20"
                >
                  Add
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
  
      {/* Navigation */}
      <div className="flex justify-between pt-8">
        <Button variant="outline" onClick={handleBack}>
          <ArrowLeft className="mr-2 h-4 w-4" /> Back
        </Button>
        <Button onClick={handleNext} disabled={selectedDatasets.length === 0}>
          Next <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );

  const renderStep3 = () => (
    <div className="max-w-2xl mx-auto">
      <div className="text-center mb-8">
        <div className="flex items-center justify-center mb-4">
          <CheckCircle className="h-12 w-12 text-green-500 mr-3" />
          <h2 className="text-3xl font-bold text-primary">
            Campaign Ready to Send!
          </h2>
        </div>
        <p className="text-muted-foreground text-lg">
          Review your Launch preview below and send to selected databases
        </p>
      </div>
  
      <Card className="border-2 border-primary/20">
        <CardHeader>
          <CardTitle className="text-primary">Launch Summary</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {/* These exact labels and text */}
          <div>
            <Label className="text-sm font-medium text-muted-foreground">
              Template Name
            </Label>
            <p className="text-primary font-semibold">{templateName}</p>
          </div>
  
          {selectedProperty && (
            <div>
              <Label className="text-sm font-medium text-muted-foreground">
                Property
              </Label>
              <p className="text-primary font-semibold">
                {selectedProperty.address}
              </p>
            </div>
          )}
  
          <div>
            <Label className="text-sm font-medium text-muted-foreground">
              Target State
            </Label>
            <p className="text-primary font-semibold">{selectedState?.name}</p>
          </div>
  
          <div>
            <Label className="text-sm font-medium text-muted-foreground">
              Selected Databases
            </Label>
            <p className="text-primary font-semibold">
              {selectedDatasets.length} selected
            </p>
            {selectedDatasets.map((id) => {
              const ds = agentLists.find((l) => l.id === id);
              return (
                <div key={id} className="text-sm text-muted-foreground">
                  • {ds?.name} ({ds?.count.toLocaleString()} agents)
                </div>
              );
            })}
          </div>
  
          <div>
            <Label className="text-sm font-medium text-muted-foreground">
              Schedule Date & Time (UTC)
            </Label>
            <input
              type="datetime-local"
              className="border rounded px-3 py-2 w-full"
              min={utcToDateInputValue(new Date().toISOString())}
              value={selectedDateTime ? utcToDateInputValue(selectedDateTime) : ""}
              onChange={(e) => {
                const val = e.target.value;
                if (val) {
                  setSelectedDateTime(new Date(`${val}:00Z`).toISOString());
                } else {
                  setSelectedDateTime("");
                }
              }}
              onFocus={(e) => {
                const current = selectedDateTime ? utcToDateInputValue(selectedDateTime) : utcToDateInputValue(new Date().toISOString());
                e.target.value = current;
              }}
              step="60"
            />
            {selectedDateTime && (
              <div className="mt-2 text-xs text-muted-foreground space-y-1">
                <p>UTC: {new Date(selectedDateTime).toISOString().replace("T", " ").slice(0, 19)} UTC</p>          
              </div>
            )}
          </div>
  
          <div>
            <Label className="text-sm font-medium text-muted-foreground">
            Launch Subject
            </Label>
            <div className="flex items-center gap-2 mt-1">
              <Input
                type="text"
                placeholder="Enter subject"
                value={subject}
                onChange={(e) => {
                  setSubject(e.target.value);
                  if (error && e.target.value.trim()) setError("");
                }}
                className={`flex-1 ${error ? "border-red-500" : ""}`}
              />
              <Button
                variant="outline"
                onClick={handleRegenerateSubject}
                disabled={generationCount >= MAX_GENERATIONS || isRegenerating}
                className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white disabled:opacity-50"
              >
                <RefreshCw
                  className={`h-4 w-4 mr-2 ${
                    isRegenerating ? "animate-spin" : ""
                  }`}
                />
                {getButtonText()}
              </Button>
            </div>
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
          </div>
        </CardContent>
      </Card>
  
      <div className="flex justify-between items-center pt-8">
        <Button variant="outline" onClick={handleBack}>
          <ArrowLeft className="mr-2 h-4 w-4" /> Back
        </Button>
        <Button
          onClick={handleNext}
          disabled={
            planLoading || countLoading || selectedDatasets.length === 0
          }
          className="bg-green-600 hover:bg-green-700 text-white px-8"
        >
          {planLoading || countLoading ? (
            <>
              Checking <Loader2 className="ml-2 h-4 w-4 animate-spin" />
            </>
          ) : (
            <>
              Send Launch <Send className="ml-2 h-4 w-4" />
            </>
          )}
        </Button>
      </div>
    </div>
  );

  if (!EmailEditor) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <p className="text-lg font-medium text-gray-600">
          Loading Template Builder…
        </p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <main className="flex-1 p-6">
                <PageHeader
            title="Template Wizard"
            subtitle="Build your template step by step"
          />

        <div
          className={`${
            currentStep === 1 ? "max-w-none" : "max-w-4xl"
          } mx-auto`}
        >

          <div className="flex justify-center mb-5 mt-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                    currentStep >= i ? "bg-primary text-white" : "bg-muted"
                  }`}
                >
                  {i}
                </div>
                {i < 3 && (
                  <div
                    className={`w-12 h-0.5 mx-2 ${
                      currentStep > i ? "bg-primary" : "bg-muted"
                    }`}
                  />
                )}
              </div>
            ))}
          </div>

          <Card className="shadow-elevated">
            <CardContent className="p-8">
              {currentStep === 1 && renderStep1()}
              {currentStep === 2 && renderStep2()}
              {currentStep === 3 && renderStep3()}
            </CardContent>
          </Card>
        </div>
      </main>

      {/* Delete Confirmation Dialog */}
      {/* <AlertDialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete Template?</AlertDialogTitle>
            <AlertDialogDescription>
              This action cannot be undone. "{templateName}" will be permanently removed.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={handleDelete} className="bg-destructive text-destructive-foreground">
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog> */}
    </div>
  );
}
